import { observable, makeObservable } from 'mobx';
import { FieldStatus } from 'chaika-enums';

export interface AllergyParams {
    id: string;
    allergen: string;
    reactionIds: string[];
    customReactions: string[];
    status: FieldStatus;
    isDefault?: boolean;
}

export class Allergy {
    @observable public id: string;
    @observable public allergen: string;
    @observable public reactionIds: string[];
    @observable public customReactions: string[];
    @observable public status: FieldStatus;
    @observable public isDefault?: boolean;

    constructor({ id, allergen = '', reactionIds = [], customReactions = [], status, isDefault }: AllergyParams) {
        makeObservable(this);

        this.id = id;
        this.allergen = allergen;
        this.reactionIds = reactionIds;
        this.customReactions = customReactions;
        this.status = status;
        this.isDefault = isDefault;
    }

    public serialize(): AllergyParams {
        return {
            id: this.id,
            allergen: this.allergen,
            reactionIds: this.reactionIds,
            customReactions: this.customReactions,
            status: this.status,
            isDefault: this.isDefault,
        };
    }
}
